import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { TierKey, UpgradeRequestView } from '../../subscription.js';
import { DecideUpgradeInput, GrantTierInput, TierConfigInput, UpgradeQueueItem, } from './schemas.js';
export const adminSubscriptionsRoutes = {
    upgradeQueue: {
        method: 'GET',
        path: '/admin/upgrade-requests',
        query: CursorQuery,
        response: Paginated(UpgradeQueueItem),
    },
    decideUpgrade: {
        method: 'POST',
        path: '/admin/upgrade-requests/:requestId',
        body: DecideUpgradeInput,
        response: UpgradeRequestView,
    },
    tierConfig: {
        method: 'PUT',
        path: '/admin/tiers/:tier',
        body: TierConfigInput,
        response: z.object({ tier: TierKey }),
    },
    grantTier: {
        method: 'POST',
        path: '/admin/members/:userId/tier',
        body: GrantTierInput,
        response: z.object({ userId: z.string(), tier: TierKey }),
    },
};
//# sourceMappingURL=routes.js.map